import styled from 'styled-components';
import { Text } from '@shared/ui-components';

const Container = styled.div`
  margin-top: 20px;
  ${Text} {
    margin-top: 5px;
  }
`;

export const Styled = {
  Container,
};
